import React from 'react';
import { SelectionChangeFunction, Study } from '../../StudyList';
import { Button, Icon, IconList } from 'components/core';
import {
  TAGS_SIDEBAR_ID,
  requestOpenSidebar,
  useSidebarChangeEvent,
} from 'pages/StudyList/StudyListToolbar/sidebarEvents';

type AddTagButtonProps = {
  studyId: Study['id'];
  onSelectionChange: SelectionChangeFunction;
};

export const AddTagButton = ({
  studyId,
  onSelectionChange,
}: AddTagButtonProps) => {
  const openSidebar = useSidebarChangeEvent();

  return (
    <Button
      role="button"
      aria-expanded={openSidebar === 'tags'}
      aria-controls={TAGS_SIDEBAR_ID}
      size="sm"
      type="brand"
      variant="ghost"
      onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
        onSelectionChange(studyId, true);
        requestOpenSidebar({ name: 'tags', trigger: event.currentTarget });
      }}
      data-pendo-key="add-tag-button"
    >
      <Icon icon={IconList.light.faTag} />
      Add tag
    </Button>
  );
};
